import { NoAccessPage } from '@mysaiva/core'
import { useAuthentication } from '@mysaiva/core/authentication'
import { useTranslation } from 'react-i18next'

/**
 * Screen shown to an authenticated user whose product_list is empty.
 *
 * SAIV-11238: having no products is an authorization outcome, so it renders
 * "Access denied" with next steps rather than the generic "Oops" ErrorPage.
 */
export function NoProductsScreen() {
  const { t } = useTranslation()
  const { user } = useAuthentication()
  const name = user?.name?.trim()

  const intro = name
    ? t('errors.noProducts.greeting', { name })
    : t('errors.noProducts.message')

  return (
    <NoAccessPage
      title={t('errors.noProducts.title')}
      message={`${intro} ${t('errors.noProducts.contactAdmin')}`}
      buttonLabel={t('errors.accessDenied.goHome')}
    />
  )
}
